<template>
<div>
    <div style="font-size: 18px;margin: 10px 20px;">商家列表</div>
    <van-list>
        <van-cell style="text-align: center" v-for="(item, index) in merchantList" :key="index" :title="item.name" @click.stop="selectMerchant(item)"/>
    </van-list>
</div>
</template>
<script>
export default {
    data() {
        return {
            merchantList: []
        }
    },
    created() {
        this.getMerchantList()
    },
    methods: {
        getMerchantList() {
            this.$http.get(`/scrm/v1/user-info/o/adminList`).then((response) => {
                const { code, data, msg } = response
                if (code === 1 && data && data.length) {
                    this.merchantList = data
                    if (this.merchantList.length === 1) {
                        // 如果只存在一个商家的商家列表
                        this.$store.dispatch('setTenancyId', this.merchantList[0].id)
                        if (this.$store.state.auth.cpType === 4) {
                            this.handleGetIsBind()
                        } else {
                            this.handleRedirectSessionListView()
                        }
                    }
                } else {
                    this.$toast(`${msg}`)
                }
            })
        },
        selectMerchant(val) {
            this.$store.dispatch('setTenancyId', val.id)
            if (this.$store.state.auth.cpType === 4) {
                this.handleGetIsBind()
            } else {
                this.handleRedirectSessionListView()
            }
        },
        handleGetIsBind () {
            this.$http.get(`/scrm/v1/tenancy-user/p/isBind`, {
                params: {
                    corpId: this.$store.state.auth.corpId
                }
            }).then((response) => {
                const { code, data } = response
                if (code === 1) {
                    // 已经绑定
                    if (data && this.$store.state.auth.memberId) {
                        this.handleRedirectSessionListView()
                    } else {
                        console.log('拿到mamberzid', this.$store.state.auth.memberId)
                        console.log('请求地址', process.env.VUE_APP_BASE_URL)
                        console.log('拿userId', localStorage.getItem('userId'))
                        this.handleGetMemberId()
                    }
                }
            })
        },
        // 重定向到后端服务器进行绑定
        handleGetMemberId () {
            // + `?corpId=${this.getQueryString('corpId')}&wxCpType=${this.getQueryString('wxCpType')}`
            let redirect_uri = encodeURIComponent(process.env.VUE_APP_BASE_URL + `/p/insuite/getUserInfo/?corpId=${this.$store.state.auth.corpId}&wxCpType=${this.$store.state.auth.cpType}`)
            console.log(redirect_uri, 'redirect_uri');
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$store.state.auth.corpId}&redirect_uri=` + redirect_uri + `&response_type=code&scope=snsapi_base&state=${localStorage.getItem('userId')}#wechat_redirect`
            let dload = document.createElement("a");
            dload.href = url;
            document.body.appendChild(dload);
            dload.click();
            dload.remove();
        },
        // 跳转到相应页面
        handleRedirectSessionListView () {
            if (this.$store.state.auth.cpType === 4) {
                // 内容库
                this.$router.push('/chatContentPage')
            } else if (this.$store.state.auth.cpType === 11) {
                // 话术库
                this.$router.push('/staffContentPage')
            } else if (this.$store.state.auth.cpType === 12) {
                // 聊天提醒
                this.$router.push('/chatRemind')
            } else if (this.$store.state.auth.cpType === -1) {
                // 会话列表页
                this.$router.push('/sessionList')
            } else if (this.$store.state.auth.cpType === 13) {
                // 智能派单
                this.$router.push('/samrtSendOrder')
            }
        },
    }
}
</script>